import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './stat-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatCardComponent {
  // Required inputs
  value = input.required<string | number>();
  label = input.required<string>();

  // Optional inputs with defaults
  icon = input<string>('pi-chart-bar');
  color = input<'indigo' | 'amber' | 'green' | 'blue' | 'purple' | 'red'>('indigo');
  suffix = input<string>('');
  suffixClass = input<string>('text-xl font-normal opacity-75');

  // Helper method to get color-specific classes
  protected getColorClasses() {
    const colorMap = {
      indigo: {
        gradient: 'from-indigo-50 to-white dark:from-gray-800 dark:to-gray-900',
        accent: 'from-indigo-500 to-indigo-400',
        icon: 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/50 dark:text-indigo-300',
        text: 'text-indigo-600 dark:text-indigo-400'
      },
      amber: {
        gradient: 'from-amber-50 to-white dark:from-gray-800 dark:to-gray-900',
        accent: 'from-amber-500 to-amber-400',
        icon: 'bg-amber-100 text-amber-600 dark:bg-amber-900/50 dark:text-amber-300',
        text: 'text-amber-600 dark:text-amber-400'
      },
      green: {
        gradient: 'from-green-50 to-white dark:from-gray-800 dark:to-gray-900',
        accent: 'from-green-500 to-green-400',
        icon: 'bg-green-100 text-green-600 dark:bg-green-900/50 dark:text-green-300',
        text: 'text-green-600 dark:text-green-400'
      },
      blue: {
        gradient: 'from-blue-50 to-white dark:from-gray-800 dark:to-gray-900',
        accent: 'from-blue-500 to-blue-400',
        icon: 'bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-300',
        text: 'text-blue-600 dark:text-blue-400'
      },
      purple: {
        gradient: 'from-purple-50 to-white dark:from-gray-800 dark:to-gray-900',
        accent: 'from-purple-500 to-purple-400',
        icon: 'bg-purple-100 text-purple-600 dark:bg-purple-900/50 dark:text-purple-300',
        text: 'text-purple-600 dark:text-purple-400'
      },
      red: {
        gradient: 'from-red-50 to-white dark:from-gray-800 dark:to-gray-900',
        accent: 'from-red-500 to-red-400',
        icon: 'bg-red-100 text-red-600 dark:bg-red-900/50 dark:text-red-300',
        text: 'text-red-600 dark:text-red-400'
      }
    };

    return colorMap[this.color()];
  }
}
